type AccountCreationConfirmationError = {
  isAccountInvalid: {
    isPasswordInvalid: boolean;
    isPasswordConfirmationInvalid: boolean;
    isUsernameInvalid: boolean;
    isCompanyInvalid: boolean;
    isAddressMissing: boolean;
  };
  isPlanzoneInvalid: {
    isNameInvalid: boolean;
    isDomainInvalid: boolean;
  };
  message: string;
};

const accountCreationConfirmationError: AccountCreationConfirmationError = {
  isAccountInvalid: {
    isAddressMissing: false,
    isCompanyInvalid: false,
    isPasswordConfirmationInvalid: false,
    isPasswordInvalid: false,
    isUsernameInvalid: false,
  },
  isPlanzoneInvalid: {
    isDomainInvalid: false,
    isNameInvalid: false,
  },
  message: "",
};

export type { AccountCreationConfirmationError };

export { accountCreationConfirmationError };
